import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
var ChevronRight = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5.16666 2.33331L10.8333 7.99998L5.16666 13.6666",
            stroke: "#007c92",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    });
};
export default /*#__PURE__*/ memo(ChevronRight);
